import React from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { createStackNavigator } from '@react-navigation/stack';
import { Ionicons } from '@expo/vector-icons';

// Screens
import Dashboard from '../screens/home/Dashboard';
import PesaScreen from '../screens/pesa/PesaScreen';
import SomaScreen from '../screens/soma/SomaScreen';
import EventsScreen from '../screens/events/EventsScreen';
import EventDetailScreen from '../screens/events/EventDetailScreen';
import EventAddScreen from '../admin/screens/EventAddScreen';
import SocialNavigator from './SocialNavigator';
import ConnectTabButton from '../components/common/ConnectTabButton';
import ViewProfileScreen from '../screens/profile/ViewProfileScreen';
import AccountProgressScreen from '../screens/home/AccountProgressScreen';
import EditProfileScreen from '../screens/profile/EditProfileScreen';
import FeedbackScreen from '../screens/profile/FeedbackScreen';
import NotificationsScreen from '../screens/home/NotificationsScreen';
import HelpScreen from '../screens/profile/HelpScreen';
import TermsScreen from '../screens/profile/TermsScreen';
import HoneyPotScreen from '../screens/home/HoneyPotScreen';

// New Screens
import IntuitLMSScreen from '../screens/soma/IntuitLMSScreen';
import LMSProgressScreen from '../screens/soma/LMSProgressScreen';
import MarketplaceScreen from '../screens/pesa/MarketplaceScreen';
import BusinessDetailScreen from '../screens/pesa/BusinessDetailScreen';
import CreateBusinessScreen from '../screens/pesa/CreateBusinessScreen';
import MyBusinessesScreen from '../screens/pesa/MyBusinessesScreen';
import CartScreen from '../screens/pesa/CartScreen';
import CheckoutScreen from '../screens/pesa/CheckoutScreen';
import OrderHistoryScreen from '../screens/pesa/OrderHistoryScreen';
import WalletScreen from '../screens/pesa/WalletScreen';
import ProductDetailScreen from '../screens/pesa/ProductDetailScreen';
import OrderDetailScreen from '../screens/pesa/OrderDetailScreen';
import VendorOrdersScreen from '../screens/pesa/VendorOrdersScreen';
import VendorOrderDetailScreen from '../screens/pesa/VendorOrderDetailScreen';
import SavingsScreen from '../screens/pesa/SavingsScreen';
import BudgetScreen from '../screens/pesa/BudgetScreen';
import LoanScreen from '../screens/pesa/LoanScreen';
import ServiceDetailScreen from '../screens/pesa/ServiceDetailScreen';
import ServiceCheckoutScreen from '../screens/pesa/ServiceCheckoutScreen';

// Mentor Screens
import MentorScreen from '../screens/mentor/MentorScreen';
import MentorDetailScreen from '../screens/mentor/MentorDetailScreen';
import MentorBookingScreen from '../screens/mentor/MentorBookingScreen';
import MentorSpacesScreen from '../screens/mentor/MentorSpacesScreen';
import MentorLiveRoomScreen from '../screens/mentor/MentorLiveRoomScreen';
import MentorBroadcastScreen from '../screens/mentor/MentorBroadcastScreen';
import MyBookingsScreen from '../screens/mentor/MyBookingsScreen';
import LiveRadioScreen from '../screens/social/LiveRadioScreen';
const Stack = createStackNavigator();
const Tab = createBottomTabNavigator();

// Stack navigators for each tab
const HomeStack = () => (
  <Stack.Navigator screenOptions={{ headerShown: false }}>
    <Stack.Screen name="Dashboard" component={Dashboard} />
    <Stack.Screen name="AccountProgress" component={AccountProgressScreen} />
    <Stack.Screen name="Pesa" component={PesaScreen} />
    <Stack.Screen name="Soma" component={SomaScreen} />
    <Stack.Screen name="HoneyPot" component={HoneyPotScreen} />
    <Stack.Screen name="EventsList" component={EventsScreen} />
    <Stack.Screen name="Notifications" component={NotificationsScreen} />
    <Stack.Screen name="EventAdd" component={EventAddScreen} />
    <Stack.Screen
      name="EventDetails"
      component={EventDetailScreen}
      options={{
        headerShown: true,
        title: 'Event Details',
        headerBackTitle: 'Back'
      }}
    />
    {/* LMS Screens */}
    <Stack.Screen name="IntuitLMS" component={IntuitLMSScreen} />
    <Stack.Screen name="LMSProgress" component={LMSProgressScreen} />

    {/* Marketplace Screens */}
    <Stack.Screen name="Marketplace" component={MarketplaceScreen} />
    <Stack.Screen name="BusinessDetail" component={BusinessDetailScreen} />
    <Stack.Screen name="CreateBusiness" component={CreateBusinessScreen} />
    <Stack.Screen name="MyBusinesses" component={MyBusinessesScreen} />
    <Stack.Screen name="Cart" component={CartScreen} />
    <Stack.Screen name="Checkout" component={CheckoutScreen} />
    <Stack.Screen name="OrderHistory" component={OrderHistoryScreen} />
    <Stack.Screen name="Wallet" component={WalletScreen} />
    <Stack.Screen name="ProductDetail" component={ProductDetailScreen} />
    <Stack.Screen name="OrderDetail" component={OrderDetailScreen} />
    <Stack.Screen name="VendorOrders" component={VendorOrdersScreen} />
    <Stack.Screen name="VendorOrderDetail" component={VendorOrderDetailScreen} />
    <Stack.Screen name="Savings" component={SavingsScreen} />
    <Stack.Screen name="Budgets" component={BudgetScreen} />
    <Stack.Screen name="Loans" component={LoanScreen} />
    <Stack.Screen name="ServiceDetail" component={ServiceDetailScreen} />
    <Stack.Screen name="ServiceCheckout" component={ServiceCheckoutScreen} />

    {/* Mentor Screens */}
    <Stack.Screen name="MentorHub" component={MentorScreen} />
    <Stack.Screen name="MentorDetail" component={MentorDetailScreen} />
    <Stack.Screen name="MentorBooking" component={MentorBookingScreen} />
    <Stack.Screen name="MentorSpaces" component={MentorSpacesScreen} />
    <Stack.Screen name="MentorLiveRoom" component={MentorLiveRoomScreen} />
    <Stack.Screen name="MentorBroadcast" component={MentorBroadcastScreen} />
    <Stack.Screen name="MyBookings" component={MyBookingsScreen} />
    {/* Radio */}
    <Stack.Screen name="LiveRadio" component={LiveRadioScreen} />

    {/* Support Screens */}
    <Stack.Screen name="Help" component={HelpScreen} />
    <Stack.Screen name="Terms" component={TermsScreen} />
  </Stack.Navigator>
);

const SocialStack = () => (
  <SocialNavigator />
);

const ProfileStack = () => (
  <Stack.Navigator>
    <Stack.Screen
      name="ViewProfile"
      component={ViewProfileScreen}
      options={{
        title: 'Profile',
        headerShown: false
      }}
    />
    <Stack.Screen
      name="EditProfile"
      component={EditProfileScreen}
      options={{
        title: 'Edit Profile',
        headerShown: false,
        headerBackTitle: 'Back'
      }}
    />
    <Stack.Screen
      name="Feedback"
      component={FeedbackScreen}
      options={{
        title: 'Send Feedback',
        headerShown: false,
        headerBackTitle: 'Back'
      }}
    />
  </Stack.Navigator>
);

import { getFocusedRouteNameFromRoute } from '@react-navigation/native';

const AppNavigator = () => (
  <Tab.Navigator
    screenOptions={({ route }) => ({
      tabBarShowLabel: route.name !== 'Connect',
      tabBarIcon: ({ focused, color, size }) => {
        if (route.name === 'Connect') return null;

        let iconName;
        let iconSize = focused ? 24 : 22;

        switch (route.name) {
          case 'Home':
            iconName = focused ? 'home' : 'home-outline';
            break;
          case 'Radio':
            iconName = focused ? 'radio' : 'radio-outline';
            break;
          case 'Profile':
            iconName = focused ? 'person' : 'person-outline';
            break;
        }

        return (
          <View style={styles.tabIconContainer}>
            <Ionicons name={iconName} size={iconSize} color={color} />
            {focused && <View style={styles.activeDot} />}
          </View>
        );
      },
      tabBarActiveTintColor: '#6366F1',
      tabBarInactiveTintColor: '#94A3B8',
      headerShown: false,
      tabBarStyle: ((route) => {
        const routeName = getFocusedRouteNameFromRoute(route) ?? 'Dashboard';
        if (['Marketplace', 'BusinessDetail', 'ProductDetail', 'ServiceDetail', 'ServiceCheckout', 'CreateBusiness', 'MyBusinesses', 'EventsList', 'EventDetails', 'ChatRoom', 'Cart', 'Checkout', 'OrderHistory', 'OrderDetail', 'VendorOrders', 'VendorOrderDetail', 'Wallet', 'Loans', 'MentorHub', 'MentorDetail', 'MentorBooking', 'MentorSpaces', 'MentorLiveRoom', 'LiveRadio', 'MentorBroadcast', 'MyBookings', 'HoneyPot'].includes(routeName)) {
          return { display: 'none' };
        }
        return {
          backgroundColor: '#FFFFFF',
          borderTopWidth: 1,
          borderTopColor: '#F1F5F9',
          height: Platform.OS === 'ios' ? 90 : 70,
          paddingTop: 12,
          paddingBottom: Platform.OS === 'ios' ? 30 : 12,
          elevation: 15,
          shadowColor: '#6366F1',
          shadowOffset: { width: 0, height: -4 },
          shadowOpacity: 0.08,
          shadowRadius: 12,
        };
      })(route),
      tabBarLabelStyle: {
        fontSize: 11,
        fontWeight: '700',
        marginTop: 4,
      },
    })}
  >
    <Tab.Screen name="Home" component={HomeStack} />
    <Tab.Screen
      name="Connect"
      component={SocialStack}
      options={{
        tabBarButton: (props) => (
          <ConnectTabButton {...props} focused={props.accessibilityState?.selected} />
        )
      }}
    />
    <Tab.Screen name="Radio" component={LiveRadioScreen} />
    <Tab.Screen name="Profile" component={ProfileStack} />
  </Tab.Navigator >
);

const styles = StyleSheet.create({
  tabIconContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  activeDot: {
    width: 4,
    height: 4,
    borderRadius: 2,
    backgroundColor: '#6366F1',
    marginTop: 4,
    position: 'absolute',
    bottom: -10,
  }
});

export default AppNavigator;
